import { render, staticRenderFns } from "./Kefu.vue?vue&type=template&id=248cad4d&"
import script from "./Kefu.vue?vue&type=script&lang=js&"
export * from "./Kefu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports